import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: 'input[alphabetsWithSymbols]'
})
export class AlphabetsWithSymbols {

    constructor(private _el: ElementRef) { }

    @HostListener("keydown", ["$event"]) public onKeydown(event: KeyboardEvent) {
        if (event.key !== event.key.replace(/[^A-Za-z \-_"\']*/g, '')) {
            event.preventDefault();
        }

    }
}